import { configureStore } from "@reduxjs/toolkit";
import { api as userApi } from "./services/userService";
import { api as authApi } from "./services/authService";
import { api as hospitalApi } from "./services/hospitalService";
import { api as bedRequestApi } from "./services/bedRequestService";

export const store = configureStore({
  reducer: {
    [userApi.reducerPath]: userApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [hospitalApi.reducerPath]: hospitalApi.reducer,
    [bedRequestApi.reducerPath]: bedRequestApi.reducer,
  },
  middleware: (get) => get().concat(
    userApi.middleware, 
    authApi.middleware,
    hospitalApi.middleware,
    bedRequestApi.middleware
  ),
});
